import { Button, Form } from 'react-bootstrap';

const WorkoutForm = ({ formFields, onChange }) => {
  const updateFields = (updater) => onChange((current) => updater(current));

  const handleInputChange = (index, event) => {
    updateFields((current) => current.map((field, fieldIndex) => (
      fieldIndex === index ? { ...field, [event.target.name]: event.target.value } : field
    )));
  };

  const handleAddField = () => {
    updateFields((current) => [...current, { series: '', peso: '', repeticiones: '' }]);
  };

  const handleRemoveField = (index) => {
    updateFields((current) => current.filter((_, fieldIndex) => fieldIndex !== index));
  };

  return (
    <div className="workout-form">
      {formFields.map((field, index) => (
        <div className="workout-form__block" key={index}>
          <div className="workout-form__block-header">
            <strong>Bloque {index + 1}</strong>
            {index > 0 && <Button type="button" variant="outline-danger" size="sm" onClick={() => handleRemoveField(index)}>Quitar</Button>}
          </div>
          <div className="workout-form__fields">
            <Form.Group controlId={`series-${index}`}>
              <Form.Label>Series</Form.Label>
              <Form.Control type="number" min="1" name="series" value={field.series} onChange={(event) => handleInputChange(index, event)} required />
            </Form.Group>
            <Form.Group controlId={`peso-${index}`}>
              <Form.Label>Peso (kg)</Form.Label>
              <Form.Control type="number" min="0" step="0.5" name="peso" value={field.peso} onChange={(event) => handleInputChange(index, event)} required />
            </Form.Group>
            <Form.Group controlId={`repeticiones-${index}`}>
              <Form.Label>Repeticiones</Form.Label>
              <Form.Control type="number" min="1" name="repeticiones" value={field.repeticiones} onChange={(event) => handleInputChange(index, event)} required />
            </Form.Group>
          </div>
        </div>
      ))}
      <Button type="button" variant="outline-primary" className="workout-form__add" onClick={handleAddField}>Agregar otro bloque</Button>
    </div>
  );
}

export default WorkoutForm;
